/**
 * Portfolio archive — client-side category filter (show/hide cards).
 */
export default function projectFilter() {
  const bar = document.getElementById('projectFilters');
  const grid = document.getElementById('projectsGrid');
  if (!bar || !grid) return;

  bar.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-btn');
    if (!btn) return;

    bar.querySelectorAll('.filter-btn').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    const filter = btn.dataset.filter;
    grid.querySelectorAll('.proj-card').forEach((card) => {
      const cats = (card.dataset.category || '').split(' ').filter(Boolean);
      const show = filter === 'all' || cats.includes(filter);
      card.classList.toggle('is-hidden', !show);
    });
  });
}
